import utils from './utils.js';
import init from './init.js';
import app from './app.js';
import board from './board.js';
window.DOMAIN = ""
if(location.hostname=="www.tipard.com" ||
	location.hostname=="account.tipard.com" ||
	location.hostname=="ja.tipard.com" ||
	location.hostname=="fr.tipard.com" ||
	location.hostname=="it.tipard.com" ||
	location.hostname=="es.tipard.com" ||
	location.hostname=="pt.tipard.com" ||
	location.hostname=="sv.tipard.com" ||
	location.hostname=="nl.tipard.com" ||
	location.hostname=="fi.tipard.com" ||
	location.hostname=="da.tipard.com" ||
	location.hostname=="pl.tipard.com" ||
	location.hostname=="hu.tipard.com" ||
	location.hostname=="cs.tipard.com" ||
	location.hostname=="el.tipard.com" ||
	location.hostname=="no.tipard.com" ||
	location.hostname=="tr.tipard.com" ||
	location.hostname=="ru.tipard.com" ||
	location.hostname=="ar.tipard.com" ||
	location.hostname=="zh-tw.tipard.com"){
	DOMAIN = 'https://rmwmss.tipard.com/v6/removeWM'
}else{
	DOMAIN = 'https://rmwmss.tipard.com/test/removeWM'
}


const MAX_TIME_OUT = 3 * 60 * 1000
let timer, timeOut, beginTime, dealTime

let  ajax, uploadType, imgData, maskData
let abort = false


/**
 * 显示上传提示框
 */
function showMessageBox(type, text='', feedback=true, confirm, cancel, noCancel) {
	window.scrollTo(0,0)
	$('.photo').removeClass('active');
	$('.alert-mask').css({
		'display': 'block',
		'z-index': 5
	})
	$('.image-loading-box').show()
	$('.show-message-box').hide()
	document.body.style.overflow = 'hidden';
	$('.loading-progress i').stop()
	$('.loading-progress i').width(13);
	switch(type) {
		case 'alertMessage': 
			$('.image-loading-box').removeClass('active');
			$('.show-alert').show()
			$('.warning-text').html(text)
			break
		case 'warning': 
			$('.image-loading-box').removeClass('active');
			$('.load-warning-box').show()
			$('.warning-text').html(text)
			break
		case 'error':
			$('.load-error-box').show()
			$('.error-text').html(text)
			break
		case 'loading':
			$('.image-loading-box').addClass('active');
			$('.loading-box').show();
			$('.loading-progress i').animate({
				width: 90+'%'
			}, 10000);
			break
	}
	if (noCancel){
		$('.cancel').hide()
		$('.confirm').css('float', 'none').css('margin','auto')
	} else {
		$('.cancel').show()
		$('.confirm').css('float', 'left')
	}

	$('.confirm').off()
    $('.cancel').off()
	$('.confirm').click(function() {
		$('.image-loading-box').hide()
		$('.alert-mask').hide();
		if (confirm)
			confirm()
	})
	$('.cancel').click(function() {
		$('.image-loading-box').hide()
		$('.alert-mask').hide()
		$('.maskRights .close').click()
		if (cancel)
			cancel()
	})

	if (feedback) {
		$('.feed-back-box').show()
	} else {
		$('.feed-back-box').hide()
	}
}	

/**
 * 点击取消按钮
 */
$('.cancel').click(function() {
	$('.image-loading-box').hide()
	$('.alert-mask').hide();
})
/**
 * 点击重试按钮
 */
/*$('.retry').click(function() {
	uploadImage(uploadFile)
})*/

/**
 * 点击取消上传按钮
 */
$('.cancel-upload').click(function() {
	if (ajax) {
		ajax.abort()
	}
	if (timer) {
		clearInterval(timer)
	}
	abort = true
	$('.image-loading-box').hide()
	$('.alert-mask').hide();
	document.body.style.overflow = 'auto'
})

/**
 * 上传图片
 * @param  img 		img     图片对象
 * @param  canvas 	maskCanvas maskCanvas
 */
function upload(img, maskCanvas) {
	var name=img.name;
	showMessageBox('loading', i18nWaterMark.global.t('watermark_remove_processing'))
	app.actions.renderTarget()

	if (!checkCanvasCanUpload(app.board.mask)) {
		showMessageBox('alertMessage', i18nWaterMark.global.t('watermark_select_area'), false, '', '', true)
        return false
    }

    beginTime = (new Date).getTime()

    if (app.token) {
    	maskCanvas.toBlob(function(blob) {
			var formdata = new FormData()
			formdata.append('token', app.token)
			formdata.append('name', name)
			formdata.append('mask', blob, 'mask')
			uploadImage(formdata)
		})
		return false
    }

	maskCanvas.toBlob(function(blob) {
		var formdata = new FormData()

		utils.getFilemd5(img, function(res) {
			formdata.append('img', img, 'img')
			formdata.append('mask', blob, 'mask')
			var timestamp = new Date().getTime()
			var sign = utils.encrypt(res + timestamp)
			formdata.append('sign', sign)
			formdata.append('name', name)
			if(board.task_id){
				formdata.append('task_id', board.task_id)
				board.task_id=0;
			}
			uploadImage(formdata)
			//ajaxUpload(formdata)
		})
	})
}

/**
 * 检测mask是否包含选区
 */
function checkCanvasCanUpload() {
    let ctx = app.board.mask.getContext('2d')
    let canvasData = ctx.getImageData( 0, 0, app.board.mask.width, app.board.mask.height ).data;
    for(let v = 0; v < canvasData.length; v+=4){
        if (canvasData[v] == 255 && 
            canvasData[v+1] == 255 && 
            canvasData[v+2] == 255 ) {
            return true
        }
    }
    return false
}

/**
 * ajax请求
 */
function ajaxUpload(formData) {
	//let url = 'http://44.236.17.28:8002/removeWaterMaker'
	let url = 'https://p7xfaqofxl.execute-api.us-west-2.amazonaws.com/removeWaterMaker' //使用, 需要sign
	//let url = 'http://44.236.17.28:8002/removeWaterMaker' // 需要sign
	//let url = 'https://0wsefrudti.execute-api.us-west-2.amazonaws.com/removeWaterMaker'
	//let url = 'https://hx6fj1p8gh.execute-api.us-west-2.amazonaws.com/removeWaterMaker'//http://44.236.17.28:5000/removeWaterMaker'//http://wellstar.nat300.top/removeWaterMaker'
	ajax = $.ajax({
        url: url,
        type: 'post',
        timeout : MAX_TIME_OUT,
		data: formData,
		cache: false,
		processData: false,
		// contentType: false,
        success: function (res) {
        	utils.loadImage(res, img => {
        		$('.mask').css({
					'display': 'block',
					'z-index': 1
				})
				$('.image-loading-box').hide()
				$('.show-message-box').hide()
				$('.image-loading-box').removeClass('active');
            	utils.showMask()
            	app.uploadFile.changeImage(img)
            	app.uploadFile.changeBase64(utils.getBase64Image(img))
        		let canvas = document.querySelector('#RightSaveCanvas')
        		let mask = document.querySelector('#mask')
        		init.initImage(canvas, img, mask)
				if (localStorage.getItem('save_guide')) {
					$('.photo>ul>div.btn .save_guide').addClass('active');
					localStorage.removeItem('save_guide');
				}
        	}, err => {
        		clearInterval(timer)
            	showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
            		$('.loading-progress i').stop(true).animate({
						width: 8+'%'
					}, 100)
            		upload(app.uploadFile.image, document.querySelector('#mask'))
            	})
        	})
        },
        error: function (err) {
        	// 网络请求失败
        	clearInterval(timer)
         	showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
         		$('.loading-progress i').stop(true).animate({
					width: 8+'%'
				}, 100)
        		upload(app.uploadFile.image, document.querySelector('#mask'))
        	})
        }
    });
}

/**
 * 上传图片
 */
function uploadImage(formData) {
	let url = DOMAIN+'/upload'
	ajax = $.ajax({
        url: url,
        type: 'post',
        timeout : MAX_TIME_OUT,
		data: formData,
		cache: false,
		processData: false,
		contentType: false,
        success: function (res) {
			console.log(res);
        	if (res.status == 200) {
        		app.token = res.token
        		requestDeal(app.token)
        	} else {
				if(!app.first){
					app.manage('click_remove_fail_first',res.status)
				}else{
					app.manage('click_remove_fail',res.status)
				}
        		clearInterval(timer)
	         	showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
	         		$('.loading-progress i').stop(true).animate({
						width: 8+'%'
					}, 100)
					showMessageBox('loading',i18nWaterMark.global.t('watermark_remove_processing'))
	        		upload(app.uploadFile.image, document.querySelector('#mask'))
	        	})
        	}
        },
        error: function (err) {
			console.log(err);
        	// 网络请求失败
        	clearInterval(timer)
			if(!app.first){
				app.manage('click_remove_fail_first',99)
			}else{
				app.manage('click_remove_fail',99)
			}
         	showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
         		$('.loading-progress i').stop(true).animate({
					width: 8+'%'
				}, 100)
				showMessageBox('loading',i18nWaterMark.global.t('watermark_remove_processing'))
        		upload(app.uploadFile.image, document.querySelector('#mask'))
        	})
        }
    });
}
/**
 * 请求处理
 */
function requestDeal(token) {
	dealTime = (new Date).getTime()
	app.board.mask.toBlob(function(blob) {
		var formdata = new FormData()
		formdata.append('token', token)
		//判断是否登录 
		var user=getCookie('user')
		if(user){
			user=JSON.parse(getCookie('user'))
			formdata.append('t_id',user.t_id)
			formdata.append('e_id',user.e_id)
			formdata.append('lToken', user.token)
		}else{
			formdata.append('e_id',utils.murmur())
			// formdata.append('e_id','asdasdasdsadasdewfwef1')
		}
		let url = DOMAIN + '/WM' 
		ajax = $.ajax({
	        url: url,
	        type: 'post',
	        timeout : MAX_TIME_OUT,
			data: formdata,
			cache: false,
			processData: false,
			contentType: false,
	        success: function (res) {
				console.log(res);
	        	if (res.status == 200) {
	        		getResult(token);
					timer = setInterval(function() {
						getResult(token)
					}, 3000)
	        	} else if(res.status==400){
					// 没有e_id或者token
					error(i18nWaterMark.global.t('error_40001'));
					$('.alert-mask').hide();
					$('.show-message-box').hide();
				} else if(res.status==401){
					// 大小超了
					error(i18nWaterMark.global.t('watermark_beyond_10M'));
					$('.alert-mask').hide();
					$('.show-message-box').hide();
					if(!app.first){
						app.manage('trigger_rights_first','size');
					}else{
						app.manage('trigger_rights','size');
					}
				} else if(res.status==402){
					// 宽高超了
					error(i18nWaterMark.global.t('watermark_beyond_4k'));
					$('.alert-mask').hide();
					$('.show-message-box').hide();
					if(!app.first){
						app.manage('trigger_rights_first','resolving_power');
					}else{
						app.manage('trigger_rights','resolving_power');
					}
				} else if(res.status==403){
					// 权益超了
					app.token = ''
					console.log(res.status);
					$('.alert-mask').hide();
					$('.show-message-box').hide();
				} else if(res.status==404){
					if(!error_fn(20005)){
						app.noMember()
						$('.alert-mask').hide();
						$('.show-message-box').hide();
						return false;
					};
				}else {
	        		clearInterval(timer)
		         	showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
		         		$('.loading-progress i').stop(true).animate({
							width: 8+'%'
						}, 100)
						showMessageBox('loading',i18nWaterMark.global.t('watermark_remove_processing'))
		        		requestDeal(token)
		        	})
	        	}
				if(res.status!=200){
					if(!app.first){
						app.manage('click_remove_fail_first',res.status)
					}else{
						app.manage('click_remove_fail',res.status)
					}
				}
	        },
	        error: function (err) {
				console.log(err)
	        	// 网络请求失败
	        	clearInterval(timer)
				if(!app.first){
					app.manage('click_remove_fail_first',99)
				}else{
					app.manage('click_remove_fail',99)
				}
	         	showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
	         		$('.loading-progress i').stop(true).animate({
						width: 8+'%'
					}, 100)
					showMessageBox('loading',i18nWaterMark.global.t('watermark_remove_processing'))
	        		requestDeal(token)
	        	})
	        }
	    });
	})
}

/**
 * 查询结果
 */
function getResult(token) {
	let url = DOMAIN + '/status'
	app.token=token;
	ajax = $.ajax({
		url: url,
		type: 'post',
		timeout: 3000,
		data: {token:token},
		success: function(res) {
			console.log(res);
			if (res.status == 200) {
				// 允许用户下载
				app.downJson=res

				clearInterval(timer)
				utils.loadImage(res.url, img => {
					if(!app.first){
						app.manage('click_remove_success_first',(( (new Date).getTime() - beginTime)/1000).toFixed(1) + 'S')
					}else{
						app.manage('click_remove_success',(( (new Date).getTime() - beginTime)/1000).toFixed(1) + 'S')
					}
					console.log('总耗时：' , (( (new Date).getTime() - beginTime)/1000).toFixed(1) + 'S')
					// console.log('处理耗时：' , (( (new Date).getTime() - dealTime)/1000).toFixed(1) + 'S')
					app.token = res.token
	        		$('.mask').css({
						'display': 'block',
						'z-index': 1
					})
					$('.image-loading-box').hide()
					$('.show-message-box').hide()
					$('.alert-mask').hide()
					$('.image-loading-box').removeClass('active');
	            	utils.showMask()
	            	app.uploadFile.changeImage(img)
	            	app.uploadFile.changeBase64(utils.getBase64Image(img))
	        		let canvas = document.querySelector('#RightSaveCanvas')
	        		let mask = document.querySelector('#mask')
	        		init.initImage(canvas, img, mask)
					if (localStorage.getItem('save_guide')) {
						$('.save_guide').addClass('active');
						localStorage.removeItem('save_guide');
					}
	        	}, err => {
	        		clearInterval(timer)
					if(!app.first){
						app.manage('click_remove_fail_first',99)
					}else{
						app.manage('click_remove_fail',99)
					}
	        		showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
		         		$('.loading-progress i').stop(true).animate({
							width: 8+'%'
						}, 100)
						showMessageBox('loading',i18nWaterMark.global.t('watermark_remove_processing'))
		        		getResult(token)
						timer = setInterval(function() {
							getResult(token)
						}, 3000)
		        	})
	        	})
			}else if(res.status == 201){
				clearTimeout(timeOut);
				timeOut = setTimeout(function(){
					getResult(token)
				},3000)
			}else {
        		clearInterval(timer)
	         	showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
	         		$('.loading-progress i').stop(true).animate({
						width: 8+'%'
					}, 100)
					showMessageBox('loading',i18nWaterMark.global.t('watermark_remove_processing'))
	        		getResult(token)
	        	})
        	}
		},
		error: function(err) {
			// 网络请求失败
			clearInterval(timer)
			if(!app.first){
				app.manage('click_remove_fail_first',99)
			}else{
				app.manage('click_remove_fail',99)
			}
			showMessageBox('warning', i18nWaterMark.global.t('watermark_remove_upload_error'), true, function() {
         		$('.loading-progress i').stop(true).animate({
					width: 8+'%'
				}, 100)
				showMessageBox('loading',i18nWaterMark.global.t('watermark_remove_processing'))
        		getResult(token)
				timer = setInterval(function() {
					getResult(token)
				}, 3000)
        	})
		}
	});
};

/**
 * 下载图片
 * type 0:正常下载 1:裁剪下载 2:历史记录下载 3:打开历史记录里的图
 */
function getDownload(type,arr,callback){
	console.log(type)
	app.LoginSuccess();
	// 判断是否有去水印操作
	if(type==1&&!app.downJson || type==0&&!app.downJson){
		return false;
	};
	// 判断是否有传裁剪
	if(type==1){
		var rect=arr;
	}else{
		var rect=[];
	}
	var user=getCookie('user')
	var data=null;
	if(user){
		user=JSON.parse(getCookie('user'))
		if(type==2 || type==3){
			data={
				key:arr[0],
				task_id:arr[1],
				e_id:user.e_id,
				t_id:user.t_id,
				lToken:user.token,
				rect:rect,
			}
		}else{
			data={
				key:app.downJson.url,
				task_id:app.downJson.task_id,
				e_id:user.e_id,
				t_id:user.t_id,
				lToken:user.token,
				rect:rect,
			}
		}
	}else{
		data={
			key:app.downJson.url,
			task_id:app.downJson.task_id,
			e_id:utils.murmur(),
			rect:rect,
		}
	}
	if(app.visitor2Login){
		data.visitor2Login=1
		app.visitor2Login='';
	}
	if(app.original){
		data.original=1;
		data.status=app.token;
	}
    if(!app.first){
		app.manage('click_down_first','')
    }else{
		app.manage('click_down','')
    }
	$.ajax({
		url: DOMAIN+'/download',
		type: 'post',
		data:data,
		success:function(res){
			console.log(res);
			if(res.status==400){
				app.manage('click_down_fail','400')
				error(i18nWaterMark.global.t('error_40001'));
				$('.alert-mask').hide();
				$('.image-loading-box').hide();
				return false;
			}
			if(type==3){
				utils.loadImage(res.url, img => {
					board.task_id=arr[1];
					var base64String=utils.getBase64Image(img);
					var imgArr = base64String.split(',');
					var mime = imgArr[0].match(/:(.*?);/)[1];
					var suffix = mime.split("/")[1];
					var bstr = atob(imgArr[1]);
					var n = bstr.length;
					var u8arr = new Uint8Array(n);
					while (n--) {
					  u8arr[n] = bstr.charCodeAt(n);
					}
					console.log(u8arr);
					//转换成file对象
					var file = new File([u8arr], res.name, { type: mime });
					app.benefitStatus(function(){
						$('.edit_box>.uploadBox').hide();
						if(callback){
							callback();
						}
						window.uploadInit(file);
					},function(){
						$('.image-loading-box').hide()
						$('.alert-mask').hide();
					})
	        	})
			}else{
				utils.loadImage(res.url,function(img){
					let url=window.URL.createObjectURL(utils.convertBase64UrlToBlob(utils.getBase64Image(img)));
					if(res.window==true){
						if(!app.first){
							app.manage('trigger_rights_first','down');
						}else{
							app.manage('trigger_rights','down');
						}
						$('.maskRights').show();
						$('.maskRightsBox').show().siblings().hide();
						$('.maskRightsBox .tip').html(i18nWaterMark.global.t('no_user_down').replace('%s',app.subscriptions.credit.quota).replace('%s',app.subscriptions.credit.threshold))
						$('.maskRightsBox .tip_btn .down').css('display','inline-block').attr('href',res.url).siblings('.cancel').hide();
						$('.maskRightsBox .tip_btn .upgrade_btn').css('display','inline-block');
						$('.maskRightsBox .tip_btn .MemberLogin').hide();
						$('.maskRightsBox .tip').append('<i>'+i18nWaterMark.global.t('no_user_login')+'<i>')
					}else{
						app.manage('click_down_success','primary')
						const a = document.createElement('a');
						a.setAttribute('download', res.name);
						a.setAttribute('href',url);
						a.click();
					}
					if(callback){
						callback();
					}
				})
			}

		},
		error:function(err){
			app.manage('click_down_fail','99')
			error(i18nWaterMark.global.t('error_40099'));
			$('.alert-mask').hide();
			$('.image-loading-box').hide();
		}
	})
}

export default {
	upload: upload,
	showMessageBox: showMessageBox,
	getDownload:getDownload,
}
